// DisciplineChecks.js — Electrical / Structural checkboxes for intake and Edit Project.

import React from 'react';
import { DISCIPLINES } from '../disciplines';

const DisciplineChecks = ({ value, onChange, locked = [] }) => {
  const toggle = (key) => {
    if (locked.includes(key)) return;
    const next = value.includes(key) ? value.filter(k => k !== key) : [...value, key];
    onChange(DISCIPLINES.map(d => d.key).filter(k => next.includes(k)));
  };
  return (
    <div style={styles.row}>
      {DISCIPLINES.map(d => {
        const on = value.includes(d.key);
        const isLocked = locked.includes(d.key);
        return (
          <label key={d.key} style={{ ...styles.box, borderColor: on ? '#112b49' : '#d1d5db', backgroundColor: on ? 'rgba(100,149,237,0.12)' : 'white', cursor: isLocked ? 'default' : 'pointer' }}
            title={isLocked ? 'This discipline already has work recorded and can’t be removed here.' : undefined}>
            <input type="checkbox" checked={on} disabled={isLocked} onChange={() => toggle(d.key)} style={{ marginRight: '0.5rem' }} />
            {d.label}
          </label>
        );
      })}
    </div>
  );
};

const styles = {
  row: { display: 'flex', gap: '0.75rem', flexWrap: 'wrap' },
  box: { display: 'flex', alignItems: 'center', padding: '0.55rem 1rem', border: '2px solid', borderRadius: '6px', fontSize: '0.95rem', fontWeight: '600', color: '#112b49', userSelect: 'none' },
};

export default DisciplineChecks;
